export const doesBrandAffinityMatchSearch = (level: string, search: string) =>
  !search.length || level.toLowerCase().includes(search.toLowerCase());
